import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { Calendar, dateFnsLocalizer, } from '@raux/ra-react-big-calendar';
import { startOfMonth, endOfMonth } from 'date-fns';
//import "react-big-calendar/lib/css/react-big-calendar.css";
import format from 'date-fns/format';
import getDay from 'date-fns/getDay';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import './CesMonthView.css';
import 'react-datepicker/dist/react-datepicker.css';
import '!style-loader!css-loader!@raux/ra-react-big-calendar/lib/css/react-big-calendar.css';
import 'react-datepicker/dist/react-datepicker.css';
import { MonthViewEventTemplate } from '../MonthViewEventTemplate/MonthViewEventTemplate';
import { FXPServiceCatalog, FxpServiceFactory } from '@fxp/fxpservices-di';
import CalendarService from '../../services/Calendar.service';
import { CECalendarEventViewType, } from '../../../common/Contracts';
import moment from 'moment';
import { FlightingService } from '../../services/Flighting.Service';
function CESMonthViewComponent(props) {
    const [isFeatureEnabled, setIsFeatureEnabled] = useState(false);
    useEffect(() => {
        const flightingService = FlightingService.getInstance();
        flightingService.evaluateFeatureFlag(['CESEditAssignment']).then((result) => {
            setIsFeatureEnabled(result === null || result === void 0 ? void 0 : result.CESEditAssignment);
        }).catch(() => setIsFeatureEnabled(false));
    }, []);
    //#region Injected services
    const userInfo = FxpServiceFactory.getServiceInstance(FXPServiceCatalog.UserInfoService);
    const loaderService = FxpServiceFactory.getServiceInstance(FXPServiceCatalog.PageLoaderService);
    const locales = {
        'en-IN': require('date-fns/locale/en-IN'),
    };
    const localizer = dateFnsLocalizer({
        format,
        parse,
        startOfWeek,
        getDay,
        locales,
    });
    let calendarService = CalendarService.getSingleton();
    //#endregion
    //#region Handle props
    let monthDateIdx = props[0];
    let calEventTypeIdx = props[1];
    let onSelectEventIdx = props[2];
    let onSelectSlotIdx = props[3];
    let onUpdateForecastIdx = props[4];
    let inputDate = (monthDateIdx === null || monthDateIdx === void 0 ? void 0 : monthDateIdx.value) || new Date();
    let calEventType = CECalendarEventViewType[calEventTypeIdx === null || calEventTypeIdx === void 0 ? void 0 : calEventTypeIdx.value] ||
        CECalendarEventViewType.OUTLOOK;
    let onSelectEvent = (onSelectEventIdx === null || onSelectEventIdx === void 0 ? void 0 : onSelectEventIdx.value) ||
        (() => console.log('No handler passed for onSelectEvent'));
    let onSelectSlot = (onSelectSlotIdx === null || onSelectSlotIdx === void 0 ? void 0 : onSelectSlotIdx.value) ||
        (() => console.log('No handler passed for onSelectSlot'));
    let onUpdateForecast = (onUpdateForecastIdx === null || onUpdateForecastIdx === void 0 ? void 0 : onUpdateForecastIdx.value) ||
        (() => console.log('No handler passed for onUpdateForecast'));
    //#endregion
    const [allEvents, setAllEvents] = useState([]);
    const [currentDate, setCurrentDate] = useState(new Date(inputDate));
    //#region EventHandlers
    const handleSelectedDate = (date) => {
        setCurrentDate(date);
    };
    const handleSelectEvent = (event) => {
        onSelectEvent(event);
    };
    const handleSelectSlot = (event) => {
        onSelectSlot(event);
    };
    const handleShowMore = (event) => {
        onSelectEvent(event);
    };
    const handleUpdateForecast = (event) => {
        onUpdateForecast(event);
    };
    const getEventStyles = (event, startDate, endDate, isSelected) => {
        let category = event.customProperties.eventCategory;
        let styleObj = {};
        let className = 'ra-ces-monthview-event';
        switch (category) {
            case 'talentforecast':
                if (event.customProperties.isUserUpdated) {
                    styleObj.backgroundColor = '#37a3ac';
                    styleObj.borderLeft = '8px solid #106168';
                }
                else {
                    styleObj.backgroundColor = '#e6e6e6';
                    styleObj.borderLeft = '8px solid #575757';
                }
                styleObj.padding = '5px';
                break;
            case 'outlook':
                styleObj.backgroundColor = 'rgb(235, 243, 252)';
                styleObj.borderTop = '0px';
                styleObj.borderRight = '0px';
                styleObj.borderBottom = '0px';
                styleObj.borderLeft = '8px solid rgb(64, 152, 252)';
                styleObj.padding = '5px';
                break;
            case 'project':
                styleObj.backgroundColor = '#99F6E4';
                styleObj.borderTop = '0px';
                styleObj.borderRight = '0px';
                styleObj.borderBottom = '0px';
                styleObj.borderLeft = '8px solid #008272';
                styleObj.padding = '5px';
                break;
            case 'msvacation':
                styleObj.backgroundColor = '#B4A0FF';
                styleObj.borderTop = '0px';
                styleObj.borderRight = '0px';
                styleObj.borderBottom = '0px';
                styleObj.borderLeft = '8px solid #5C2D91';
                styleObj.padding = '5px';
                break;
            case 'publicholiday':
                styleObj.backgroundColor = '#B4A0FF';
                styleObj.borderTop = '0px';
                styleObj.borderRight = '0px';
                styleObj.borderBottom = '0px';
                styleObj.borderLeft = '8px solid #5C2D91';
                styleObj.padding = '5px';
                break;
            case 'nonproject':
                if (event.customProperties.AssignmentType == 'ROSS Pending') {
                    styleObj.backgroundColor = '#F7C17E';
                    styleObj.borderLeft = '8px solid #A42E00';
                }
                else {
                    styleObj.backgroundColor = '#869F12';
                    styleObj.borderLeft = '8px solid #0b400b';
                }
                styleObj.borderTop = '0px';
                styleObj.borderRight = '0px';
                styleObj.borderBottom = '0px';
                styleObj.padding = '5px';
                break;
            default:
                styleObj.backgroundColor = '#E3008C';
                styleObj.borderTop = '0px';
                styleObj.borderRight = '0px';
                styleObj.borderBottom = '0px';
                styleObj.borderLeft = '8px solid #B4009E';
                styleObj.padding = '5px';
                break;
        }
        return { className, style: styleObj };
    };
    //#endregion
    // Function to split multi-day events into individual daily events
    const splitMultiDayEvents = (events) => {
        // Create a new array to hold the processed events
        const result = [];
        // Process each event
        events.forEach(event => {
            // Process project events with schedules
            if (event.customProperties.eventCategory === 'project' &&
                event.customProperties.Schedules &&
                Array.isArray(event.customProperties.Schedules) &&
                event.customProperties.Schedules.length > 0) {
                // Extract the original start time to preserve it
                const originalStart = moment(event.start);
                const originalHour = originalStart.hour();
                const originalMinute = originalStart.minute();
                const originalSecond = originalStart.second();
                // Sort schedules by date to ensure chronological order
                const sortedSchedules = [...event.customProperties.Schedules].sort((a, b) => {
                    return moment(a.forecastDate).diff(moment(b.forecastDate));
                });
                // Flag to track if we've processed the first day
                let isFirstDay = true;
                // Create new events for each schedule element (only if duration > 0)
                sortedSchedules.forEach(schedule => {
                    // Skip schedules with zero duration
                    if (schedule.durationInHours <= 0) {
                        return;
                    }
                    // Create a deep copy of the original event
                    const newEvent = JSON.parse(JSON.stringify(event));
                    // Set the Schedules array to contain only this single schedule element
                    newEvent.customProperties.Schedules = [schedule];
                    // Keep isNonContiguousAssignment as true since this split event is part of a larger non-contiguous assignment
                    newEvent.customProperties.isNonContiguousAssignment = event.customProperties.Schedules.length > 1;
                    // Update totalScheduledHours for this individual schedule - keep the total from original event.
                    newEvent.customProperties.totalScheduledHours = event.customProperties.Schedules.reduce((sum, sched) => sum + (sched.durationInHours || 0), 0);
                    // Add the entire assignment schedule to customProperties
                    newEvent.customProperties.assignmentSchedules = event.customProperties.Schedules;
                    // Initialize scheduleDate with the forecast date
                    const scheduleDate = moment(schedule.forecastDate);
                    // For the first day, preserve original start time; for subsequent days, start at midnight
                    if (isFirstDay) {
                        scheduleDate.hour(originalHour).minute(originalMinute).second(originalSecond);
                        isFirstDay = false; // Mark that we've processed the first day
                    }
                    else {
                        scheduleDate.hour(0).minute(0).second(0); // Set to midnight for subsequent days
                    }
                    // Set start date to the schedule's forecast date with appropriate time
                    newEvent.start = scheduleDate.toDate().toString();
                    // Calculate end date by adding the duration hours to the start date
                    const endDate = scheduleDate.clone().add(schedule.durationInHours, 'hours');
                    newEvent.end = endDate.toDate().toString();
                    // Update tooltip to reflect the new dates
                    const startFormatted = scheduleDate.format('YYYY-MM-DD HH:mm:ss');
                    const endFormatted = endDate.format('YYYY-MM-DD HH:mm:ss');
                    newEvent.tooltip = `${newEvent.customProperties.ResourceRequestId} | ${newEvent.customProperties.RequestType} | ${startFormatted} to ${endFormatted} | Requested Duration - ${schedule.durationInHours}`;
                    result.push(newEvent);
                });
            }
            // All other events are kept as-is
            else {
                result.push(event);
            }
        });
        return result;
    };
    useEffect(() => {
        loaderService.fnShowPageLoader('Loading...');
        const startDate = startOfMonth(currentDate); //start of month for given date
        const endDate = endOfMonth(currentDate);
        const fisWeekStartDate = startOfWeek(currentDate, { weekStartsOn: 6 });
        let apiStartDate = new Date(fisWeekStartDate);
        // If month start is after fis week start -
        if (startDate.getTime() - fisWeekStartDate.getTime() > 0) {
            apiStartDate = new Date(startDate);
        } // If month start is after now time
        else if (startDate.getTime() - new Date().getTime()) {
            apiStartDate = new Date(startDate);
        }
        (() => __awaiter(this, void 0, void 0, function* () {
            let recommendedHours = yield calendarService.fetchTalentRecommendedHours(userInfo.getCurrentUser(), apiStartDate, //current fiscal start if it lies in cur month else month start
            endDate // end of month
            );
            let calendarEvents = yield calendarService.fetchCalendarData(startDate, endDate);
            let talentForecast = yield calendarService.fetchTalentForecast(userInfo.getCurrentUser(), startDate, endDate);
            let mergedForecasts = calendarService.mergeForecasts(recommendedHours.availableHours, talentForecast, startDate, endDate);
            let parsedCalendarEvents = calendarService.parseCalendarResponse(calendarEvents.calendarEvents);
            let assignmentEvents = calendarService.parseAssignments(recommendedHours.eventDetails);
            const mergedEvents = [
                ...mergedForecasts,
                ...parsedCalendarEvents,
                ...assignmentEvents,
            ];
            // Apply the splitting function
            if (isFeatureEnabled) {
                const processedEvents = splitMultiDayEvents(mergedEvents);
                setAllEvents(processedEvents);
            }
            else {
                setAllEvents(mergedEvents);
            }
            loaderService.fnHidePageLoader();
        }))();
        return () => {
            loaderService.fnHidePageLoader();
        };
    }, [currentDate, isFeatureEnabled]);
    return (React.createElement("div", { className: "monthly-calendar" },
        React.createElement(Calendar
        // schedule settings
        , { 
            // schedule settings
            events: allEvents, localizer: localizer, date: currentDate, startAccessor: "start" //event object are expected to have start and end property
            , endAccessor: "end", tooltipAccessor: "tooltip", style: { height: '90vh' }, onSelectEvent: handleSelectEvent, onSelectSlot: handleSelectSlot, selectable: true, calendarEventType: calEventType, handleSelectedDate: handleSelectedDate, showAllEvents: false, onShowMore: handleShowMore, popup: false, doShowMoreDrillDown: false, eventPropGetter: getEventStyles, components: {
                month: {
                    event: MonthViewEventTemplate,
                },
            } })));
}
export default CESMonthViewComponent;
//# sourceMappingURL=CesMonthView.js.map